export default "__VITE_ASSET__9db5ef19__"